import React, { useEffect, useState } from "react";
// import share from "../../../Assets/Images/share.png";
import AppointmentService from "../../../Services/AppointmentService";
import PatientService from "../../../Services/PatientService";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { useHistory } from "react-router-dom";
import { IoMdVideocam } from "react-icons/io";
import { MdCall } from "react-icons/md";
import Edit from "../../../Assets/Images/Svg/EditIcon.svg";
import Preview from "../../../Assets/Images/Svg/PreviewIcon.svg";
import { Button, Checkbox, message, Modal, Spin, Tooltip } from "antd";
import PrescriptionDetails from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import ConsultationService from "../../../Services/ConsultationService";
import { RWebShare } from "react-web-share";
// import close from "../../../Assets/Images/close.png";
import shareIcon from "../../../Assets/Images/Svg/shareIcon.svg";
import MedicineDisabled from "../../../Assets/Images/Svg/MedicineDisabled.svg";
import LabDisabled from "../../../Assets/Images/Svg/LabDisabled.svg";
import ShareOrders from "../NewDashboard/ShareOrders";
import SharePrescription from "../NewDashboard/SharePrescription";
import { IoPersonSharp } from "react-icons/io5";
import { Input } from "antd";
import { BiVideoPlus } from "react-icons/bi";
import user from "../../../Assets/Icons/user1.svg";
import edit from "../../../Assets/Icons/edit1.svg";
import view from "../../../Assets/Icons/visibility.svg";
import share from "../../../Assets/Icons/share1.svg";
import tablet from "../../../Assets/Icons/tablt.svg";
import lab from "../../../Assets/Icons/lab1.svg";
import close from "../../../Assets/Icons/close1.svg";
import moment from "moment";
import EditWhite from "../../../Assets/Images/Svg/EditWhite.svg";
import ViewWhite from "../../../Assets/Images/Svg/ViewWhite.svg";
import ShareWhite from "../../../Assets/Images/Svg/ShareWhite.svg";
import MedWhite from "../../../Assets/Images/Svg/MedWhite.svg";
import LabWhite from "../../../Assets/Images/Svg/LabWhite.svg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import RxImage from "../../../Assets/Images/Svg/RxImage.svg";
import RescheduleAppt from "../NewDashboard/RescheduleAppt";
import { useDispatch } from "react-redux";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import CommonFunctions from "../../Shared/CommonFunctions";
import Summary from "../VideoConsultation/Summary";
import { notifyPatient } from "../../../config/firebase";
import { setSelectedAppt } from "../../../Redux/actions/UserActions";

const AppointmentCard = () => {
  const [appointmentData, setAppointmentData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [cancelAppointmentID, setCancelAppointmentID] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const { TextArea } = Input;
  const [refundable, setRefundable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const showModal = (record) => {
    setIsModalOpen(true);
    setCancelAppointmentID(record);
  };

  const handlePreviewOk = () => {
    setPreview(false);
  };
  const handlePreviewCancel = () => {
    setPreview(false);
  };

  useEffect(() => {
    getAppointmentList();
  }, []);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      getAppointmentList(page);
    }
  };

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const getAppointmentList = (pageNo = 1, pageSize = 8) => {
    const fromDate = new Date();
    const formattedDate = fromDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_Id: loginResultObject.user.clinic_Id,
      fromDate: formattedDate,
      pageNo: pageNo,
      pageSize: pageSize,
    };

    AppointmentService.AppointmentFilter(payload)
      .then((res) => {
        setAppointmentData(res.data);

        if (res.data.length === pageSize) {
          setTotalPages(pageNo + 1);
        } else {
          setTotalPages(pageNo);
        }

        setCurrentPage(pageNo);
      })
      .catch((err) => {
        console.error("Error fetching appointment data:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const history = useHistory();

  const handleClick = async (record) => {
    dispatch(getLoaderState(true));
    try {
      let payload = {
        patientId: record.patientId,
      };
      PatientService.PatientListFilter(payload).then((res) => {
        sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
      });
      let apptPayload = {
        appointmentId: record.appointmentId,
      };
      let result = await AppointmentService.AppointmentFilter(apptPayload);
      await notifyPatient(record.patientId, record.appointmentId, record.userName, record.userId);
      dispatch(setSelectedAppt(record));
      sessionStorage.setItem("selectedAppt", JSON.stringify(record));
      history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: result?.data[0] });
      window.scrollTo(0, 0);
    } catch (error) {
      message.error("An error occured try again");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  const dispatch = useDispatch();

  const getInitials = (name) => {
    if (!name) return "";
    name = name.replace(/^Mr\.?\s*/, "").trim();
    const initials = name.slice(0, 1).toUpperCase();
    return initials;
  };

  const formatTime = (time) => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return formattedTime;
  };

  const showPreview = async (record) => {
    let patientPayload = {
      patientId: record?.patientId,
    };
    let consultationPayload = {
      consultationId: record?.consultationId,
      detailsYN: "Y",
    };
    try {
      const patientResponse = await PatientService.PatientListFilter(
        patientPayload
      );
      if (patientResponse) {
        setSelectedPatient(patientResponse.data[0]);
      }
      const consultationResponse = await ConsultationService.getPrescriptions(
        consultationPayload
      );
      if (consultationResponse.data) {
        setSelectedPrescription(consultationResponse.data[0]);
        setPreview(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const cancelAppointment = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    if (cancelReason === "") {
      message.error("Enter reason");
      return;
    }
    let payload = {
      appointmentId: cancelAppointmentID.appointmentId,
      cancelReason: cancelReason,
      cancelledById: cancelAppointmentID.userId,
      cancelledByType: "USER",
      refundYN: refundable ? "Y" : "N",
      paymentType: cancelAppointmentID.paymentType,
    };
    try {
      AppointmentService.AppointmentCancelNew(payload).then((res) => {
        setIsModalOpen(false);
        getAppointmentList();
        message.success("Appointment Cancelled");
      });
      setCancelAppointmentID({});
    } catch (error) {
      message.error("Please try again");
    }
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center mt-40">
          <Spin />
        </div>
      ) : (
        <div className="mx-4 my-2">
          {appointmentData.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
              {appointmentData.map((data, index) => (
                <div key={index} className="w-full border rounded-md shadow-sm">
                  <div className="flex items-center justify-between p-3">
                    <div className="flex items-center gap-2">
                      {data.photoName ? (
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL + data?.photoName
                          }
                          alt={data.name}
                          className="w-10 h-10 rounded-full"
                        />
                      ) : (
                        <div className="h-10 w-10 rounded-full flex items-center justify-center text-white bg-brand-primaryColor">
                          <span>{getInitials(data.patientName)}</span>
                        </div>
                      )}
                      <div>
                        <h2 className="font-semibold text-gray-800 text-sm">
                          {data.patientName}
                        </h2>
                        <h4 className="text-xs text-gray-500">
                          {data.patientId}
                        </h4>
                      </div>
                    </div>
                    {data.status === 1 ? (
                      <div className="flex items-center gap-2">
                        <Tooltip placement="left" title={"Share"}>
                          <button className="p-2 bg-teal-100 rounded-full">
                            <RWebShare
                              data={{
                                text: "Appointment",
                                url:
                                  `${process.env.REACT_APP_WEBSITEURL}vc?ref=` +
                                  data?.appointmentId +
                                  "/N",
                                title: "Share Link",
                              }}
                            >
                              <img
                                src={share}
                                alt="Share"
                                className="w-5 h-5"
                              />
                            </RWebShare>
                          </button>
                        </Tooltip>
                        <Tooltip placement="right" title={"Cancel"}>
                          <button className="p-2 bg-red-100 rounded-full">
                            <img
                              onClick={() => showModal(data)}
                              src={close}
                              alt="Close"
                              className="w-5 h-5"
                            />
                          </button>
                        </Tooltip>
                        <RescheduleAppt
                          record={data}
                          getList={getAppointmentList}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <hr className="" />

                  {/* Details */}
                  <div className="space-y-2 text-gray-700 p-3">
                    <div className="flex">
                      <p className="font-semibold text-xs w-32 text-gray-500">
                        Appointment ID:
                      </p>
                      <p className="font-semibold text-xs text-gray-800">
                        {data?.appointmentId}
                      </p>
                    </div>
                    <div className="flex">
                      <p className="font-semibold text-xs w-32 text-gray-500">
                        Chief Complaint:
                      </p>
                      <p className="font-semibold text-xs  text-gray-800">
                        {data?.appointmentReason}
                      </p>
                    </div>

                    <div className="flex items-center">
                      <span className="text-xl flex text-gray-500 w-32">
                        <img src={RxImage} alt="" /> <span>:</span>
                      </span>

                      {data.status === 2 ? (
                        <div className="flex gap-2">
                          <div
                            onClick={() => handleClick(data)}
                            className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
                          >
                            <img src={edit} alt="" />
                          </div>
                          <Tooltip placement="top" title={"View Prescription"}>
                            <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                              <img
                                src={view}
                                alt=""
                                onClick={() => showPreview(data)}
                              />
                            </div>
                          </Tooltip>
                          <SharePrescription record={data} />
                        </div>
                      ) : (
                        <div className="flex gap-2">
                          <button className="p-2 bg-gray-300 rounded-full">
                            <img
                              src={EditWhite}
                              alt="Edit"
                              className="w-5 h-5"
                            />
                          </button>
                          <button className="p-2 bg-gray-300 rounded-full">
                            <img
                              src={ViewWhite}
                              alt="View"
                              className="w-5 h-5"
                            />
                          </button>
                          <button className="p-2 bg-gray-300 rounded-full">
                            <img
                              src={ShareWhite}
                              alt="Share"
                              className="w-5 h-5"
                            />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Orders Section */}
                    <div className="flex items-center">
                      <p className="font-semibold text-xs mt-3 w-32 text-gray-500">
                        Orders:
                      </p>
                      {data.status === 2 ? (
                        <div className="flex gap-2">
                          <ShareOrders
                            record={data}
                            getList={getAppointmentList}
                          />
                        </div>
                      ) : (
                        <div className="flex gap-2">
                          <button className="p-2 bg-gray-300 rounded-full">
                            <img
                              src={MedWhite}
                              alt="Tablet"
                              className="w-5 h-5"
                            />
                          </button>
                          <button className="p-2 bg-gray-300 rounded-full">
                            <img src={LabWhite} alt="Lab" className="w-5 h-5" />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Appointment Status */}
                    <div className="flex items-center">
                      <p className="font-semibold text-xs w-32 text-gray-500">
                        Appointment Status:
                      </p>
                      <p className={`font-semibold text-xs`}>
                        {data.status === 9 && (
                          <span className=" text-red-500 " disabled>
                            Cancelled
                          </span>
                        )}
                        {data.status === 0 && (
                          <span className=" text-yellow-500 ">Pending</span>
                        )}
                        {data.status === 1 && (
                          <span className=" text-yellow-500 ">Pending</span>
                        )}
                        <div className="flex gap-3 items-center">
                          {data.status === 2 && (
                            <span className=" text-green-500 ">Completed</span>
                          )}
                          {data.status === 2 && data.serviceCode === "APPT_INPERSON" &&
                            <Summary
                              record={data}
                            />
                          }
                        </div>
                      </p>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="bg-teal-50 h-12 p-3 rounded-md flex justify-between items-center">
                    <span className="text-gray-800 text-xs font-semibold">
                      {moment
                        .utc(data.appointmentDate)
                        .local()
                        .format("DD/MM/YYYY")}
                      -{data.startTime}
                    </span>
                    {data.status === 2 || data.status === 9 ? (
                      <button
                        className=" md:px-3 px-2 py-2 rounded flex items-center gap-1 text-white  bg-gray-400 cursor-not-allowed"
                        disabled
                      >
                        {data.serviceCode === "APPT_VIDEO" || data.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {data.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                Audio
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5 " /> Consult
                          </>
                        )}
                      </button>
                    ) : !data.transactionId &&
                      data.paymentConsultation === "BC" ? (
                      <Tooltip
                        placement="top"
                        title={"payment is not completed"}
                      >
                        <button
                          className="bg-brand-primaryColor text-white px-3 py-2 rounded flex items-center gap-1"
                          disabled
                        >
                          {data.serviceCode === "APPT_VIDEO" || data.serviceCode === "APPT_AUDIO" ? (
                            <>
                              {data.serviceCode === "APPT_VIDEO" ? (
                                <>
                                  <BiVideoPlus className="w-5 h-5" />
                                  Join call
                                </>
                              ) : (
                                <>
                                  <MdCall className="w-5 h-5" />
                                  Audio
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <IoPersonSharp className="w-5 h-5" /> Consult
                            </>
                          )}
                        </button>
                      </Tooltip>
                    ) : (
                      <button
                        onClick={() => handleClick(data)}
                        className="bg-brand-primaryColor text-white px-3 py-2 text-sm rounded flex items-center gap-1"
                      >
                        {data.serviceCode === "APPT_VIDEO" || data.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {data.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                Audio
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5" /> Consult
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center font-bold my-40">No Appointments!</div>
          )}
          <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
            <div className="flex items-center justify-center space-x-2">
              <button
                className={`p-2 rounded-md ${currentPage === 1
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
                  }`}
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FaChevronLeft className="text-[#189FAA]" />
              </button>

              {[...Array(totalPages)].map((_, index) => {
                const page = index + 1;
                return (
                  <button
                    key={page}
                    className={`px-3 py-1 rounded-md ${currentPage === page
                      ? "bg-teal-500 text-white text-sm"
                      : "text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                      }`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                );
              })}

              <button
                className={`p-2 rounded-md ${currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
                  }`}
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FaChevronRight className="text-[#189FAA]" />
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
        open={preview}
        onOk={handlePreviewOk}
        onCancel={handlePreviewCancel}
        style={{
          top: 40,
        }}
        width={"70%"}
        footer={null}
      >
        <PrescriptionDetails
          prescription={selectedPrescription}
          selectedPatient={selectedPatient}
        />
      </Modal>
      <Modal
        title="Cancel Appointment"
        open={isModalOpen}
        // onOk={handleOk}
        onCancel={cancelAppointment}
        footer={[]}
        width={400}
        destroyOnClose
      >
        <div>
          <span className="font-sans font-normal text-s">
            Are you sure you want to cancel this appointment?
          </span>
          <div className="relative mt-5">
            <textarea
              onChange={(e) => {
                setCancelReason(e.target.value);
              }}
              rows="4"
              className="peer w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#189FAA] text-sm font-medium text-[#333] bg-transparent"
            />
            <label
              className="absolute left-2 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-2 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
              htmlFor="cancelReason"
            >
              Cancel Reason...
            </label>
            <Checkbox
              checked={refundable}
              disabled={
                cancelAppointmentID?.status === 0 ||
                cancelAppointmentID?.status === 9 ||
                (cancelAppointmentID?.paymentType === "FullDiscount" &&
                  cancelAppointmentID?.status === 1)
                //   ||
                // cancelAppointmentID?.paymentType === "Cash"
              }
              onChange={handleRefundable}
              className="text-[#969CA5] gap-2"
            />
            <label className="text-[#A0A2A3] ">Refund Applicable</label>
          </div>
          <div className="flex justify-end border-brand-colorBorder gap-3 mt-10">
            <Button
              className="h-8 Btnwhite  w-20 text-[#189FAA]"
              onClick={cancelAppointment}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              className="h-8 w-40 font-sans font-semibold bg-brand-primaryColor"
              type="primary"
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AppointmentCard;
